function assetHideOrShowAccountDropdown(){
  const checkedValue = $('input:radio[name="financial_asset[selected_bank]"]:checked').val();
  if ( checkedValue == 'default' || checkedValue == 'cash'){
    $('.selected-bank-account-dropdown').fadeOut('slow');
  }else{
    $('.selected-bank-account-dropdown').fadeIn('slow');
  }
}

$(document).ready(function() {
  if ($('#assets-form').length > 0 ){
    checkAmount('.amount', '.amount-div')

    var selectedBankAccount = $('.asset-bank-radio').data('selected-bank-account');

    if (selectedBankAccount == 'default'){
      $('input:radio[name="financial_asset[selected_bank]"]:nth(0)').attr('checked',true);
    }else{
      $('input:radio[name="financial_asset[selected_bank]"]:nth(1)').attr('checked',true);
    }

    assetHideOrShowAccountDropdown();

    $('input[name="financial_asset[selected_bank]"]').change(function(){
      assetHideOrShowAccountDropdown();
    });
  }

  if ($('.amount-div').length > 0){

    if ($('#equities-form').length > 0){
      checkAmount('.amount', '.amount-div')
    }

    if ($('#payable-accounts-form').length > 0){
      checkAmount('.amount','.amount-div')
    }

    if ($('#retirements-form').length > 0){
      checkAmount('.amount','.amount-div')
    }
  }
});
